import { DEFAULT_MENU_COVER } from '@liveHelper/constants'
import { css } from 'twind/css'

export const mutedText = css({
  color: 'var(--gray-8)',
})

export const textChatLink = css({
  color: 'var(--blue) !important',
  textAlign: 'center',
  border: 'none',
})

export const offlineText = css({
  color: 'var(--gray-9)',
})

export const contentSection = css`
  flex-grow: 1;

  @media screen and (max-height: 500px) {
    transform: scale(0.9);
    padding-top: 10px;
    overflow-y: auto;
  }

  @media screen and (max-height: 320px) {
    transform: scale(0.8);
    padding-top: 10px;
    overflow-y: auto;
  }
`

export const menuCoverImage = (backgroundImage?: string) => css`
  ${
    backgroundImage
      ? `
    background-image: url(${backgroundImage});  
    background-size: cover;
  `
      : `
    background-image: url(${DEFAULT_MENU_COVER});
    background-size: contain;
    background-position: calc(50% + 30px) 10px;
  `
  }
  background-repeat: no-repeat;
  height: 300px;
  width: 100%;

  @media screen and (max-height: 320px) {
    display: none;
  }
`

export const ctaContainer = css`
  @media screen and (max-height: 500px) {
    margin-top: 8px;
  }
`
